"use client";

import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";

import i18n from "../lib/i18n";

export const LanguageProvider = ({ children }) => {
  // Render children immediately, including during SSR, so page content is
  // present in the server-rendered HTML for crawlers and AI tools. i18n is
  // initialised synchronously at module load with bundled resources and a
  // fixed initial language ("en"), so the server and the first client render
  // always match (no hydration mismatch). After hydration we switch to the
  // visitor's preferred language: their saved choice first, otherwise their
  // browser language if we ship that translation.
  useEffect(() => {
    const supported = Object.keys(i18n.options.resources || {});
    const saved = localStorage.getItem("keystone-language");

    let target = saved && supported.includes(saved) ? saved : null;
    if (!target) {
      const nav = (navigator.language || "").toLowerCase();
      target =
        supported.find((lng) => lng === nav) ||
        supported.find((lng) => nav.startsWith(lng)) ||
        null;
    }

    if (target && target !== i18n.language) {
      i18n.changeLanguage(target);
    }
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
